import React from "react";
import { Input } from "@/components/ui/input";
import { Filter, BookmarkPlus, Check } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { t } from "@/i18n";

const inputCls = "bg-[#FFFAF0] border-[#D8CFBB] text-[#1A1610] focus-visible:ring-[#C5A880] h-9";

/** Property filters strip (city + max price) with Save/Reset actions. */
export default function PropertyFilters({
  city,
  setCity,
  maxPrice,
  setMaxPrice,
  hasAny,
  onReset,
  onSave,
  saved,
  onClearAll,
  showClearAll,
}) {
  const { lang } = useApp();
  return (
    <div
      className="flex items-center gap-3 flex-wrap p-3 rounded-lg border border-[#D8CFBB] bg-[#FFFAF0]"
      data-testid="mk-props-filters"
    >
      <Filter className="h-4 w-4 text-[#C5A880]" />
      <Input
        data-testid="mk-filter-city"
        placeholder={t("city_placeholder", lang)}
        value={city}
        onChange={(e) => setCity(e.target.value)}
        className={`${inputCls} max-w-[200px]`}
      />
      <Input
        data-testid="mk-filter-max-price"
        placeholder={t("max_price_placeholder", lang)}
        type="number"
        value={maxPrice}
        onChange={(e) => setMaxPrice(e.target.value)}
        className={`${inputCls} max-w-[200px]`}
      />
      {hasAny && (
        <button onClick={onReset} data-testid="mk-props-reset" className="text-xs text-[#C5A880] hover:underline">
          {t("reset", lang)}
        </button>
      )}
      <div className="ms-auto flex items-center gap-2">
        <button
          onClick={onSave}
          data-testid="mk-save-filters"
          className="inline-flex items-center gap-1 text-xs text-[#4A3F30] hover:text-[#1A1610] px-3 py-1.5 border border-[#D8CFBB] rounded-full hover:bg-[#EBE3D3]"
        >
          {saved ? <Check className="h-3 w-3 text-emerald-700" /> : <BookmarkPlus className="h-3 w-3 text-[#C5A880]" />}
          {saved ? t("saved", lang) : t("save_filters", lang)}
        </button>
        {showClearAll && (
          <button onClick={onClearAll} data-testid="mk-clear-all" className="text-xs text-red-700 hover:underline">
            {t("clear_saved", lang)}
          </button>
        )}
      </div>
    </div>
  );
}
